<script>
import Layout from "@layouts/form";
import Fatura from "@forms/Fatura";

export default {
  page: {
    title: "Detalhes | Fatura"
  },
  components: {
    Layout,
    Fatura
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Fatura",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Fatura",
          href: "/Fatura"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Fatura :editable="editable"></Fatura>
    </div>
  </Layout>
</template>
